import { render } from "./OrderDetailsReceiptButtons.vue?vue&type=template&id=354d8fef"
import script from "./OrderDetailsReceiptButtons.vue?vue&type=script&lang=js"
export * from "./OrderDetailsReceiptButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__